/**
 * Initial shown in HeaderAvatarButton — the Settings entry point added in #531.
 * Falls back displayName → email local-part → null (caller renders an icon).
 */
export const initialFor = (
  displayName?: string | null,
  email?: string | null,
): string | null => {
  const source = displayName?.trim() || email?.trim().split('@')[0] || '';
  // Array.from avoids splitting a multi-byte code point mid-character.
  const first = Array.from(source)[0];
  return first ? first.toUpperCase() : null;
};

/**
 * A guest's header also carries a way to sign in (#741): a returning cook on a
 * new device was walked into a guest week with no visible door. The labelled
 * pill is ~128px; below this width a header has no room for it next to the
 * title and its other actions, so the pill drops to its icon.
 */
export const SIGN_IN_LABEL_MIN_WIDTH = 360;

export const guestSignInVariant = (
  windowWidth: number,
  compact = false,
): 'label' | 'icon' => (compact || windowWidth < SIGN_IN_LABEL_MIN_WIDTH ? 'icon' : 'label');
